import { FunctionComponent } from 'react';
import { DialogModal } from '../../../app-kit/components/DialogModal/DialogModal';
import { PropertyPageDataDisclaimerModalContentWithData } from './PropertyPageDataDisclaimerModalContent/PropertyPageDataDisclaimerModalContent';

interface PropertyPageDataDisclaimerModal {
  opened: boolean;
  onClose: () => void;
}

export const PropertyPageDataDisclaimerModal: FunctionComponent<
  PropertyPageDataDisclaimerModal
> = ({ opened, onClose }) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      title="Disclaimer"
    >
      <PropertyPageDataDisclaimerModalContentWithData />
    </DialogModal>
  );
};
